//export const customerMembership = JSON.parse(localStorage.getItem('customer'));
export const  MAX_NUMBER_INGREDIENTS_FREE_SUBSCRIBER = 15
export const  MAX_NUMBER_RECIPES_FREE_SUBSCRIBER = 4
export const  MAX_NUMBER_MENUS_FREE_SUBSCRIBER = 2